import { toast } from 'sonner'
import { useMutateWithdrawTransaction } from '@/modules/transaction/api/hooks/useMutateWithdrawTransaction'
import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
} from '@/common/ui/dialog'
import { CreateWithdrawTransactionDtoType } from '@/schema'
import showErrorToast from '@/common/utils/showErrorToast'

type WithdrawData = {
	amount: number
	playerPhone: string
	bankProviderName?: string
	accountNumber?: string
	accountName?: string
	note?: string
}

type WithdrawTypeSelectionModalProps = {
	open: boolean
	onOpenChange: (open: boolean) => void
	withdrawData: WithdrawData | null
	onSuccess: () => void
}

export function WithdrawTypeSelectionModal({
	open,
	onOpenChange,
	withdrawData,
	onSuccess,
}: WithdrawTypeSelectionModalProps) {
	const { createWithdraw } = useMutateWithdrawTransaction()

	const handleTypeSelect = async (type: CreateWithdrawTransactionDtoType) => {
		if (!withdrawData) return

		try {
			await createWithdraw.mutateAsync({
				type,
				...withdrawData,
			})
			toast.success('สร้าง transaction สำเร็จ')
			onSuccess()
			onOpenChange(false)
		} catch (error) {
			showErrorToast(
				error instanceof Error ? error : 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
			)
		}
	}

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-[425px]">
				<DialogHeader>
					<DialogTitle>เลือกประเภทการถอน</DialogTitle>
					<DialogDescription>
						กรุณาเลือกประเภทการถอนเงินที่ต้องการดำเนินการ
					</DialogDescription>
				</DialogHeader>
				<div className="flex flex-col gap-3 py-6">
					<Button
						size="lg"
						onClick={() =>
							handleTypeSelect(CreateWithdrawTransactionDtoType.auto)
						}
						disabled={createWithdraw.isPending}
						className="h-auto flex-col items-start gap-1 py-4"
					>
						<div className="text-base font-semibold">
							Auto - ระบบถอนอัตโนมัติ
						</div>
						<div className="text-sm font-normal opacity-90">
							ระบบจะดำเนินการถอนเงินอัตโนมัติ
						</div>
					</Button>
					<Button
						size="lg"
						variant="outline"
						onClick={() =>
							handleTypeSelect(CreateWithdrawTransactionDtoType.manual)
						}
						disabled={createWithdraw.isPending}
						className="h-auto flex-col items-start gap-1 py-4"
					>
						<div className="text-base font-semibold">Manual - ถอนด้วยตนเอง</div>
						<div className="text-sm font-normal opacity-70">
							แอดมินจะดำเนินการถอนเงินด้วยตนเอง
						</div>
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}
